import * as types from '../mutation-types';
import axios from 'axios';
import config from '@/config';
import { loadData } from '@/utils/loading';


const state = {
  spaceplans: null,
  spaceplanItems: [],
};

const mutations = {
  [types.SET_SPACEPLANS]: (state, spaceplans) => {
    state.spaceplans = spaceplans;
  },
  [types.ADD_SPACEPLAN]: (state, spaceplan) => {
    state.spaceplans.push(spaceplan);
  },
  [types.UPDATE_SPACEPLAN]: (state, { spaceplan, data }) => {
    Object.assign(spaceplan, data);
  },
  [types.REMOVE_SPACEPLAN]: (state, spaceplanId) => {
    state.spaceplans.splice(state.spaceplans.findIndex(s => s.id === spaceplanId), 1);
  },
  [types.SET_SPACEPLAN_ITEMS]: (state, planItems) => {
    state.spaceplanItems = planItems;
  },
  [types.ADD_SPACEPLAN_ITEM]: (state, planItem) => {
    state.spaceplanItems.push(planItem);
  },
  [types.UPDATE_SPACEPLAN_ITEM]: (state, payload) => {
    payload.planItem.left = payload.planItemData.left;
    payload.planItem.top = payload.planItemData.top;
  },
  [types.REMOVE_SPACEPLAN_ITEM]: (state, id) => {
    state.spaceplanItems.splice(
      state.spaceplanItems.findIndex(s => s.id === id), 1,
    );
  },
};

const getters = {
  getSpaceplans: state => state.spaceplans,
  getDefaultSpacePlan(state) {
    const result = (
      state.spaceplans ? state.spaceplans.filter(spaceplan => spaceplan.default) : null
    );
    return result && result.length > 0 ? result[0] : null;
  },
  getSpaceplanById: state => id => (
    state.spaceplans ? state.spaceplans.filter(
      spaceplan => spaceplan.id === id,
    )[0] : undefined),
  getSpaceplanItems: state => spaceplanId => state.spaceplanItems.filter(
    item => item.spaceplan === spaceplanId,
  ),
};

const actions = {
  async loadSpaceplans({ commit, rootState }) {
    const url = new URL(
      config.ICOOL.API.USER_SPACEPLANS_PATH(rootState.snapshot.currentSnapshot.id),
      config.ICOOL.BACKEND_HOST,
    ).href;
    return loadData(commit, types.SET_SPACEPLANS, url);
  },
  addSpaceplan({ commit, rootState }, formData) {
    const url = new URL(
      config.ICOOL.API.USER_SPACEPLANS_PATH(rootState.snapshot.currentSnapshot.id),
      config.ICOOL.BACKEND_HOST,
    ).href;
    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          commit(types.ADD_SPACEPLAN, response.data);
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        })
        .finally(() => {
        });
    });
  },
  updateSpaceplan({ commit, rootState }, payload) {
    const url = new URL(
      config.ICOOL.API.USER_SPACEPLAN_PATH(payload.spaceplan.snapshot, payload.spaceplan.id),
      config.ICOOL.BACKEND_HOST,
    ).href;

    const headers = {};

    if (payload.image) {
      headers['Content-Type'] = 'multipart/form-data';
    }

    return new Promise((resolve, reject) => {
      axios
        .patch(url, payload.data, {
          headers,
        })
        .then((response) => {
          commit(types.UPDATE_SPACEPLAN, { spaceplan: payload.spaceplan, data: response.data });
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        })
        .finally(() => {
        });
    });
  },
  removeSpaceplan({ commit, rootState }, spaceplanId) {
    const url = new URL(
      config.ICOOL.API.USER_SPACEPLAN_PATH(rootState.snapshot.currentSnapshot.id, spaceplanId),
      config.ICOOL.BACKEND_HOST,
    ).href;
    return new Promise((resolve, reject) => {
      axios
        .delete(url)
        .then((response) => {
          commit(types.REMOVE_SPACEPLAN, spaceplanId);
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        })
        .finally(() => {
        });
    });
  },
  addSpaceplanItem({ commit }, spaceplanItem) {
    const url = new URL(
      config.ICOOL.API.USER_SPACEPLANS_ITEMS_PATH(spaceplanItem.spaceplan),
      config.ICOOL.BACKEND_HOST,
    ).href;
    return new Promise((resolve, reject) => {
      axios
        .post(url, spaceplanItem)
        .then((response) => {
          commit(types.ADD_SPACEPLAN_ITEM, response.data);
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        })
        .finally(() => {
        });
    });
  },
  updateSpaceplanItem({ commit }, { planItem, planItemData }) {
    const url = new URL(
      config.ICOOL.API.USER_SPACEPLANS_ITEMS_UPDATE_PATH(planItem.spaceplan, planItem.id),
      config.ICOOL.BACKEND_HOST,
    ).href;
    return new Promise((resolve, reject) => {
      axios
        .patch(url, planItemData)
        .then((response) => {
          commit(types.UPDATE_SPACEPLAN_ITEM, { planItem, planItemData });
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        })
        .finally(() => {
        });
    });
  },
  removeSpaceplanItem({ commit }, planItem) {
    const url = new URL(
      config.ICOOL.API.USER_SPACEPLANS_ITEMS_UPDATE_PATH(planItem.spaceplan, planItem.id),
      config.ICOOL.BACKEND_HOST,
    ).href;
    return new Promise((resolve, reject) => {
      axios
        .delete(url)
        .then((response) => {
          commit(types.REMOVE_SPACEPLAN_ITEM, planItem.id);
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        })
        .finally(() => {
        });
    });
  },
  loadSpaceplanItems({ commit }, spaceplanId) {
    const url = new URL(
      config.ICOOL.API.USER_SPACEPLANS_ITEMS_PATH(spaceplanId),
      config.ICOOL.BACKEND_HOST,
    ).href;
    loadData(commit, types.SET_SPACEPLAN_ITEMS, url);
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
